import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//import App from './components/FirstChat/FirstChat.js';
//import ConfigChat from './components/ConfigChat/ConfigChat.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
